export const onPopoverClick = (e, callback) => {
  const screenSize = e.target.closest('.popover-container_tablet') ? 1100 : 767;

  if (!e.target.closest('.popover')) {
    if (window.innerWidth <= screenSize) {
      callback();
    }
  }
};
